import React, { useState, useEffect } from 'react'
import { Card, Table } from 'antd'
import { useSelector } from 'react-redux'
import { formatMessageNew, downLoadFileBlob } from '@/utils/common'
import { nfcDailyReportPage, nfcDailyReportDownload } from '@/services/Email/NFCDailyReport'
import AntdTable from '@/components/table/AntdTable'
import ActionBar from '@/components/table/ActionBar'

const NFCDailyReport = () => {
  const languageState = useSelector(state => state.commonStore.language)
  const deviceSize = useSelector(state => state.commonStore.deviceSize)

  const [tableObj, setTableObj] = useState({})
  const [settingSize, setSettingSize] = useState(20)

  useEffect(() => {
    setSettingSize(20 * deviceSize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceSize])

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.sendTime'),
      dataIndex: 'sendTime',
      width: '120px',
      render: () => {
        return <div className="word_break_word">{tableObj.dateRange}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.totalLines'),
      dataIndex: 'totalLines',
      width: '100px'
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.sendPass'),
      dataIndex: 'sendPass',
      width: '100px'
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.sendFail'),
      dataIndex: 'sendFail',
      width: '100px'
    }
  ]
  const tableColumnsSync = [
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.syncDate'),
      dataIndex: 'sendTime',
      width: '100px',
      render: () => {
        return <div className="word_break_word">{tableObj.dateRange}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.vendor'),
      dataIndex: 'vendorName',
      width: '100px'
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.nfcDataCneterReceived'),
      dataIndex: 'nfcDataCenterReceived',
      width: '100px'
    }
  ]
  const tableColumnsWms = [
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.date'),
      dataIndex: 'sendTime',
      width: '120px',
      onCell: (_, index) => {
        let len = (tableObj.wmsTaggingDataDTO && tableObj.wmsTaggingDataDTO.plantTags.length) || 1
        if (index === 0) {
          return {
            rowSpan: len
          }
        }
        if (index > 0 && index < len) {
          return {
            rowSpan: 0
          }
        }
        return { colSpan: 1 }
      },
      render: () => {
        return <div className="word_break_word">{tableObj.dateRange}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.plant'),
      dataIndex: 'plantCode',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.nfcSentToAnt'),
      dataIndex: 'sendToAnt',
      width: '100px'
    },
    {
      title: formatMessageNew('languageObj.emailNfcDailyReport.failed'),
      dataIndex: 'failed',
      width: '100px'
    }
  ]
  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const searchDataFun = () => {
    const params = {}
    nfcDailyReportPage(params).then(res => {
      const dt = res.resultData
      setTableObj(dt)
    })
  }
  const downLoadFun = () => {
    const params = {
      isChinese: languageState === 'zh_CN' ? true : false
    }
    nfcDailyReportDownload(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 20 }}>
        <div>
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end', paddingRight: 0, paddingBottom: 0 }}>
            <div style={{ fontSize: settingSize }}>
              {formatMessageNew('languageObj.emailNfcDailyReport.nfcDailyReport')}
            </div>
          </ActionBar>
          {/* <Button onClick={downLoadFun} type="primary">
            {formatMessageNew('languageObj.commonLocale.download')}
          </Button> */}
        </div>
      </Card>
      <div className="mb20">
        <div className="mt30">
          <Card bordered={false} bodyStyle={{ padding: 20 }}>
            <AntdTable
              title={() => (
                <div className="fwb mt5 mb5">
                  {formatMessageNew('languageObj.emailNfcDailyReport.nfcDataSendToAnt')}
                </div>
              )}
              dataSource={(tableObj.nfcDataSendAntDTO && [tableObj.nfcDataSendAntDTO]) || []}
              columns={tableColumns}
            />
          </Card>
        </div>

        <div className="mt30">
          <Card bordered={false} bodyStyle={{ padding: 20 }}>
            <AntdTable
              title={() => (
                <div className="fwb mt5 mb5">{formatMessageNew('languageObj.emailNfcDailyReport.uidSyncData')}</div>
              )}
              dataSource={tableObj.vendorSyncDataDTOs || []}
              columns={tableColumnsSync}
            />
          </Card>
        </div>

        <div className="mt30">
          <Card bordered={false} bodyStyle={{ padding: 20 }}>
            <AntdTable
              title={() => (
                <div className="fwb mt5 mb5">{formatMessageNew('languageObj.emailNfcDailyReport.wmsTaggingData')}</div>
              )}
              dataSource={
                (tableObj.wmsTaggingDataDTO && tableObj.wmsTaggingDataDTO && tableObj.wmsTaggingDataDTO.plantTags) || []
              }
              columns={tableColumnsWms}
              summary={() => {
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={2}>
                        <div className="fwb">{formatMessageNew('languageObj.commonLocale.total')}</div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2}>
                        <div className="fwb">{tableObj.wmsTaggingDataDTO && tableObj.wmsTaggingDataDTO.total}</div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3}>
                        <div className="fwb">
                          {tableObj.wmsTaggingDataDTO && tableObj.wmsTaggingDataDTO.failedTotal}
                        </div>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                )
              }}
            />
          </Card>
        </div>
      </div>
    </div>
  )
}
export default NFCDailyReport
